export default __webpack_public_path__ + "static/media/bussiness_insider.570a3198.png";